import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/_service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TransactionService } from 'src/app/_service/transaction.service';

@Component({
  selector: 'app-add-edit-transaction',
  templateUrl: './add-edit-transaction.component.html',
  styleUrls: ['./add-edit-transaction.component.css']
})
export class AddEditTransactionComponent implements OnInit {

  transactionForm: FormGroup; submitted = false; loading: boolean = false;
  constructor(private transactionapi: TransactionService, public sharedapi: SharedService, private formBuilder: FormBuilder, private router: Router) {
    this.transactionForm = this.formBuilder.group({
      'payment_type': [null],
      'payment_mode': [null],
      'status': [null],
      'health_plan_id': [null],
      'mobile': [null],
      'email': [null],
      'payment_link': [null],
      'reference_id': [null],
      'amount': [null],
      'payment_link_id': [null],
      'payment_id': [null],
      'lead_id': [null],
      'lab_lead_id': [null],
      'corporate_lead_id': [null],
      'request_data': [null],
      'response_data': [null],
      'description': [null]
    });

  }
  ngOnInit(): void {
  }

  get f() { return this.transactionForm.controls; }

  async createTransaction() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.transactionForm.invalid) {
      this.loading = false;
      return;
    }
    await this.transactionapi.saveTransaction(this.transactionForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/payment-transaction');
        this.transactionForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }



}
